import React from 'react';
import { Box, Container, Typography, Link, Divider } from '@mui/material';
import Grid from '@mui/material/GridLegacy';

const Footer: React.FC = () => {
  return (
    <Box
      component="footer"
      sx={{
        py: 6,
        backgroundColor: '#000000',
        borderTop: '1px solid #1A1A1A',
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          <Grid item xs={12} sm={6} md={3}>
            <Typography
              variant="h6"
              sx={{
                mb: 2,
                fontWeight: 700,
                fontSize: '1.25rem',
              }}
            >
              <span style={{ color: '#1D9BF0' }}>V</span>ECTOR
            </Typography>
            <Typography variant="body2" sx={{ color: '#9CA3AF' }}>
              Advanced intelligence data management for modern law enforcement
            </Typography>
          </Grid>
          
          <Grid item xs={12} sm={6} md={3}>
            <Typography variant="h6" sx={{ mb: 2, color: '#E7E9EA' }}>
              Product
            </Typography>
            <Link href="#features" color="inherit" underline="hover" sx={{ display: 'block', mb: 1, color: '#9CA3AF' }}>
              Features
            </Link>
            <Link href="#use-cases" color="inherit" underline="hover" sx={{ display: 'block', mb: 1, color: '#9CA3AF' }}>
              Use Cases
            </Link>
            <Link href="#technical" color="inherit" underline="hover" sx={{ display: 'block', mb: 1, color: '#9CA3AF' }}>
              Technical Specs
            </Link>
            <Link href="#" color="inherit" underline="hover" sx={{ display: 'block', color: '#9CA3AF' }}>
              Documentation
            </Link>
          </Grid>
          
          <Grid item xs={12} sm={6} md={3}>
            <Typography variant="h6" sx={{ mb: 2, color: '#E7E9EA' }}>
              Company
            </Typography>
            <Link href="#about" color="inherit" underline="hover" sx={{ display: 'block', mb: 1, color: '#9CA3AF' }}>
              About
            </Link>
            <Link href="#" color="inherit" underline="hover" sx={{ display: 'block', mb: 1, color: '#9CA3AF' }}>
              Blog
            </Link>
            <Link href="#" color="inherit" underline="hover" sx={{ display: 'block', mb: 1, color: '#9CA3AF' }}>
              Careers
            </Link>
            <Link href="#contact" color="inherit" underline="hover" sx={{ display: 'block', color: '#9CA3AF' }}>
              Contact
            </Link>
          </Grid>
          
          <Grid item xs={12} sm={6} md={3}>
            <Typography variant="h6" sx={{ mb: 2, color: '#E7E9EA' }}>
              Support
            </Typography>
            <Typography variant="body2" sx={{ color: '#9CA3AF', mb: 1 }}>
              Email: support@vectoronline.us
            </Typography>
            <Typography variant="body2" sx={{ color: '#9CA3AF', mb: 1 }}>
              Phone: (555) 123-4567
            </Typography>
            <Typography variant="body2" sx={{ color: '#9CA3AF' }}>
              Hours: 24/7 Support
            </Typography>
          </Grid>
        </Grid>
        
        <Divider sx={{ my: 4, borderColor: '#2F3336' }} />
        
        <Box sx={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap' }}>
          <Typography variant="body2" sx={{ color: '#71767B' }}>
            © 2025 VECTOR Intelligence Platform. All rights reserved.
          </Typography>
          <Box sx={{ display: 'flex', gap: 3 }}>
            <Link href="#" color="inherit" underline="hover" sx={{ color: '#71767B' }}>
              Privacy Policy
            </Link>
            <Link href="#" color="inherit" underline="hover" sx={{ color: '#71767B' }}>
              Terms of Service
            </Link>
            <Link href="#" color="inherit" underline="hover" sx={{ color: '#71767B' }}>
              Security
            </Link>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;